import './App.css';
import Axios from "axios";
import { useState } from "react";
import RecipeTile from "./RecipeTile";

function App() {
  const [query, setquery] = useState("");
  const [recipes, setrecipes] = useState([]);
  const [healthLabel, sethealthLabel] = useState("vegan")

  const YOUR_APP_ID = "f628e4da";
  const YOUR_APP_KEY = "dd9af8553bf5a56aced7847367097f23";
  var url = `https://api.edamam.com/search?q=${query}&app_id=${YOUR_APP_ID}&app_key=${YOUR_APP_KEY}&health=${healthLabel}`;

  async function getRecipes() {
    var result = await Axios.get(url);
    setrecipes(result.data.hits);
    console.log(result.data);
  }

  const onSubmit = (e) => {
    e.preventDefault(); //prevent reloading when click submit
    getRecipes();
  }

  return (
    <div className="app">
      <h1> Looking to Try a New Dish? </h1>
      <form className="appsearchform" onSubmit={onSubmit}>
        <input 
        className="appinput"
        type="text" 
        placeholder="Enter Ingridient"
        value = {query} onChange={(e) => setquery(e.target.value)} 
        />
        <input className="appsubmit" type="submit" value="Search" />
        <select className="apphealthlabels">
          <option onClick={() => sethealthLabel("vegan")}> vegan </option>
          <option onClick={() => sethealthLabel("vegetarian")}> vegetarian </option>
          <option onClick={() => sethealthLabel("paleo")}> paleo </option>
          <option onClick={() => sethealthLabel("dairy-free")}> dairy-free </option>
          <option onClick={() => sethealthLabel("gluten-free")}> gluten-free ​</option>
          <option onClick={() => sethealthLabel("wheat-free")}> wheat-free ​</option>
          <option onClick={() => sethealthLabel("fat-free")}> fat-free ​</option>
          <option onClick={() => sethealthLabel("low-sugar")}> low-sugar ​</option>
          <option onClick={() => sethealthLabel("egg-free")}> egg-free ​</option>
          <option onClick={() => sethealthLabel("peanut-free")}> peanut-free ​</option>
          <option onClick={() => sethealthLabel("tree-nut-free")}> tree-nut-free ​</option>
          <option onClick={() => sethealthLabel("soy-free")}> soy-free ​</option>
          <option onClick={() => sethealthLabel("fish-free")}> fish-free ​</option>
          <option onClick={() => sethealthLabel("shellfish-free")}> shellfish-free ​</option>
        </select>
      </form>

      <div className="apprecipes">
        {recipes.map(recipe => {
          return <RecipeTile recipe={recipe}/>;
        })}
      </div>
    </div>
  );
}

export default App;